import { baseApi } from './../baseApi';
interface Params{
    slug:string,type:string
}
const eventApi = baseApi.injectEndpoints({
    endpoints: (builder)=>({
        eventList:builder.query({
            query: (params)=>`/events?search=${params.search}`,
            providesTags:['Events']
        }),
        getUserEvents:builder.query({
            query: (params)=>`user/events?user=${params.user_id}&page=${params.page}&limit=${params.limit}`
        }),
        getEvent:builder.query({
            query: (params)=>`events/${params.slug}?type=${params.type}`
        }),
        getParticipants:builder.query({
            query: (params)=>`event/participants/${params.slug}?page=${params.page}`,
            // transformResponse:(res:any) =>res.sort((a,b)=>b.id-a.id),
            providesTags:['Participants']
        }),
        editParticipant:builder.mutation({
            query:participant=>({
                url:`event/participant/edit`,
                method: "POST",
                body:participant
            }),
            invalidatesTags:['Participants']
        }),
        removeParticipant:builder.mutation({
            query:(body)=>({
                url: `event/participant/remove`,
                method:"DELETE",
                body
            }),
            invalidatesTags:['Participants']
        }),
        registerEvent:builder.query({
            query: (params)=>`/event/register/${params.slug}`,
        }),
        registerUserForEvent:builder.mutation({
            query:body=>({
                url: `event/user/register`,
                method:"POST",
                body
            })
        })
    })
})

export const {useRegisterEventQuery,useEventListQuery, useGetUserEventsQuery, useGetEventQuery, useGetParticipantsQuery,useEditParticipantMutation, useRemoveParticipantMutation, useRegisterUserForEventMutation}= eventApi